const testimonials = [
  {
    id: 1,
    quote: '以前は保険の内容がよく分からないまま加入していましたが、岡山太郎さんに丁寧に説明していただき、家族構成やライフプランに合った保険に見直すことができました。月々の保険料も抑えられて大満足です。',
    author: 'M様',
    location: '岡山市北区在住',
    age: '40代・会社員',
    image: 'https://public.readdy.ai/ai/img_res/36cdc9a36fdd8d25dd6457c05523fa30.jpg',
  },
  {
    id: 2,
    quote: '子どもが生まれたタイミングで保険を見直したいと思い相談しました。教育資金や将来の備えについて、具体的な数字を示しながら説明してくださり、安心して加入できました。地元の代理店なので何かあった時もすぐに相談できます。',
    author: 'T様',
    location: '倉敷市在住',
    age: '30代・主婦',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20in%20her%2030s%20smiling%20warmly%20at%20home%2C%20authentic%20Japanese%20housewife%20with%20friendly%20expression%2C%20casual%20comfortable%20clothing%2C%20natural%20lighting%2C%20simple%20clean%20background%20without%20text&width=400&height=400&seq=testimonial-customer-002&orientation=squarish',
  },
  {
    id: 3,
    quote: '定年退職を控え、老後の医療保険について相談させていただきました。複数の保険会社のプランを比較しながら、私たち夫婦に最適なものを提案してくださいました。アフターフォローも丁寧で信頼できます。',
    author: 'K様',
    location: '総社市在住',
    age: '60代・自営業',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20senior%20man%20in%20his%2060s%20smiling%20kindly%2C%20authentic%20Japanese%20self-employed%20person%20with%20gentle%20expression%2C%20casual%20smart%20clothing%2C%20natural%20lighting%2C%20simple%20clean%20background%20without%20text&width=400&height=400&seq=testimonial-customer-003&orientation=squarish',
  },
];

export default function Testimonial() {
  return (
    <section className="py-16 md:py-24 bg-[#FAF8F3]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-gray-500 text-sm mb-3">お客様の声</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#2C3E50] leading-tight">
            岡山市で保険を見直して<br />
            <span className="text-[#FF9B7A]">本当に良かったです</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-white rounded-2xl p-8 md:p-10 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 flex items-center justify-center rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={testimonial.image}
                    alt={testimonial.author}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <p className="font-bold text-[#2C3E50] text-lg">
                    {testimonial.location} {testimonial.author}
                  </p>
                  <p className="text-gray-500 text-sm">
                    {testimonial.age}
                  </p>
                </div>
              </div>
              
              <div className="mb-4">
                <i className="ri-double-quotes-l text-4xl text-[#FF9B7A] opacity-30"></i>
              </div>
              
              <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                {testimonial.quote}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
